import { useModuleBEM } from "@b2bportal/core-themes";
import {
  Features,
  HomeFeatures,
  useHomeFeaturesFromHotel,
  HotelCard,
  HomeCardPretitle,
  HomeVacationRentalTag,
} from "@tenant/hotels";
import clsx from "clsx";
import styles from "./HomeAvailabilityCard.module.scss";

export type HomeAvailabilityCardProps = React.ComponentProps<typeof HotelCard>;

export const HomeAvailabilityCard = ({
  className,
  children,
  ...restProps
}: HomeAvailabilityCardProps) => {
  const [block, cn] = useModuleBEM(styles, "HomeAvailabilityCard");

  const { hotel } = restProps;

  const { maxOccupancy, numberOfBedrooms, numberOfBathrooms } =
    useHomeFeaturesFromHotel(hotel);

  if (hotel.homesListingDetails == null) return null;

  return (
    <HotelCard {...restProps} className={clsx(block, className)}>
      <HomeVacationRentalTag className={cn("vacation-rental-tag")} />
      <HomeCardPretitle className={cn("pre-title-container")} hotel={hotel} />
      <div className={cn("features")}>
        <div className={cn("features-container")}>
          <Features hotel={hotel} />
        </div>
        <HomeFeatures
          maxOccupancy={maxOccupancy}
          numberOfBedrooms={numberOfBedrooms}
          numberOfBathrooms={numberOfBathrooms}
        />
      </div>

      {children}
    </HotelCard>
  );
};
